import React from 'react';
import { Row, Col } from 'reactstrap';
import serviceList from '../../helpers/data/feature/serviceList';
import Section from '../common/Section';
import CardService from './CardService';
import SectionHeader from './SectionHeader';

const Services = ({ services, all, cols = 6 }) =>
<Section id='services' bg="light" className={`text-center ${!!all&&' py-5'}`}>
  <SectionHeader
    title="Descubre que te ofrecemos"
    subtitle="Estos son algunos de los servicios que Homelan te ofrece para optimizar tu gestión del condominio"
  />
  <Row className="mt-8">
    {(services||serviceList).map((service, i)=> !!all?
      <Col lg={cols} md={6} className={`mt-6 mt-lg-0 ${!!all&&'mb-5 pb-5'} ${i>2&&!!all&&'mt-5 pt-3'}`} key={i}>
        <CardService {...service} />
      </Col>
      :
      i<2&&
      <Col lg={cols} className={`mt-6 mt-lg-0 ${!!all&&'mb-5 pb-5'} ${i>2&&!!all&&'mt-5 pt-3'}`} key={i}>
        <CardService {...service} />
      </Col>
    )}
  </Row>
</Section>

export default Services;